import { atom } from "jotai";

export const pageTitleIsAiGeneratedAtom = atom<boolean>(false);
